import { CASHIER_STEP_STATUSES } from "../../../../../modules/Account/components/CashierSteps/cashierStepsConstants";

export const MOBILE_HISTORY_WITHDRAWAL_STEPS = [
    {
        status: CASHIER_STEP_STATUSES.COMPLETED, title: 'lite_version.history.transaction.title.created',
    },
    {
        description: 'lite_version.history.transaction.description.waiting_for_approval',
        status: CASHIER_STEP_STATUSES.IN_PROGRESS,
        title: 'lite_version.history.transaction.title.waiting_for_approval',
    },
    {
        status: CASHIER_STEP_STATUSES.WAITING, title: 'lite_version.history.transaction.title.completed',
    }
];
